const steps = [
  { i: "ri-search-eye-line", t: "搜索番剧", d: "输入番名快速定位目标动画，或按分类浏览。" },
  { i: "ri-list-check-3", t: "选择集数", d: "进入详情页挑选要观看或下载的对应集数。" },
  { i: "ri-hd-line", t: "清晰度选择", d: "支持 1080P 与 4K 等多档清晰度随心切换。" },
  { i: "ri-download-2-line", t: "一键下载", d: "复制直链或使用下载工具，即可离线收藏。" },
];

export default function DownloadGuide() {
  return (
    <section className="container-site py-10 md:py-14">
      <div className="mb-8 text-center">
        <h2 className="inline-flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
          <i className="ri-download-cloud-2-line text-primary-500" />
          三步搞定在线观看与下载
        </h2>
        <p className="mx-auto mt-2 max-w-lg text-sm text-foreground-400">
          全程无需繁琐步骤，从找番到存番一气呵成，追更体验顺滑到底。
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((s, idx) => (
          <div key={s.t} className="relative rounded-xl border border-background-800 bg-background-900 p-5">
            <span className="absolute right-4 top-3 font-heading text-4xl text-background-700/80">0{idx + 1}</span>
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
              <i className={`${s.i} text-xl`} />
            </span>
            <h3 className="mt-4 text-base font-bold text-foreground-100">{s.t}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-400">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}